
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';

import { Observable, Subject, Subscription, combineLatest, map, startWith } from 'rxjs';
import { CollectionReference } from '@angular/fire/compat/firestore';
import { CompanysitesService } from '../company-sites/company-sites.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { ConfigService } from 'src/app/shared/config';
import { OverviewService } from 'src/app/services/overview.service';


export interface PeriodicElement {
  name: string;
  id: number;
  email: string;
  rfid: number;
  status: boolean;
  type: boolean;
  dbid: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css'],


})


export class OverviewComponent implements OnInit {
  breakpoint = 3
  approvedDataSource = new MatTableDataSource(ELEMENT_DATA);
  // notApprovedDataSource = new MatTableDataSource(ELEMENT_DATA);
  siteId: string;
  user: User;
  overview$: Observable<any>;
  dbPath: CollectionReference;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  siteId$: Observable<any>;

  dialogSub: Subscription;
  paramsSub: Subscription;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: any; }[] = [];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: any; }[] = [];

  totalCount = -1;
  Closed = -1;
  Inprogress = -1;
  Open = -1;
  filter$ = new Subject()
  @ViewChild('search' , { static: false } ) searchElement: HTMLInputElement;

  constructor(
    public dialog: MatDialog,
    public auth: AuthService,
    public companyService: CompanysitesService,
    public router: Router,
    public route: ActivatedRoute,
    private overviewService: OverviewService,
    private config: ConfigService
  ) {




    this.overview$ = combineLatest(this.companyService.getAllOverviewOfMachines$(), this.overviewService.getActiveIssues$(), this.filter$.pipe(startWith("")))
    .pipe(map(([overview, issues, filter]) => {
      return overview.map(data => {
        return {
          ...data,
          issues: issues.filter(is => is['systemId'] == data['systemId']),
          index: issues.filter(is => is['systemId'] == data['systemId']).length > 0 ? -1 : 0
        }
      }).filter(option=> option['systemName'].toLowerCase().includes(filter))


    })).pipe(map(dataArray => dataArray.sort(
      (a, b) => {
        if (a['index'] < b['index'])
          return -1;
        if (a['index'] > b['index'])
          return 1;
        return 0;
      }
    )))

    // this.totalCount = this.dataSource.data.length;
    // this.Open = this.btnCategoryClick('Open');
    // this.Closed = this.btnCategoryClick('Closed');
    // this.Inprogress = this.btnCategoryClick('InProgress');


  }

  statusColor(kantineAvailble) {
    // Stored as the string "true"/"false" on most docs, but some are a real
    // boolean — normalize instead of requiring the exact string.
    if (String(kantineAvailble).toLowerCase() === "true")
      return "bg-light-success"
    else
      return "bg-light-warning"

  }

  btnCategoryClick(code) { }
  // btnCategoryClick(val: string): number {
  //   this.dataSource.filter = val.trim().toLowerCase();
  //   return this.dataSource.filteredData.length;
  // }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 400) ? 1 : 2;

    document.getElementById("search").focus()
    // write code for set focus on search input
    
  }

  onKantineOverviewClick(companyId, siteId, systemId) {
    console.log(companyId, siteId, systemId)
    this.router.navigate([companyId, siteId, systemId], { relativeTo: this.route });
  }

  applyFilter(filterValue: string) {
    this.filter$.next(filterValue.toLowerCase());
  }

  resetMachine(event, obj) {
    event.stopPropagation()
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Important",
          message: " Are you sure to continue? ",
          buttons: ['Cancel', 'Yes']
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.overviewService.resetMachine(obj.companyId, obj.siteId, obj.systemId, obj.id)

      }
    });
  }

  collectProduct(event, obj) {
    event.stopPropagation()
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "Important",
          message: " Are you sure to continue? ",
          buttons: ['Cancel', 'Yes']
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.overviewService.collectProduct(obj.companyId, obj.siteId, obj.systemId, obj.id)

      }
    });
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 2;
  }

  gotoSystem(event, companyId, siteId, systemId) {
    event.stopPropagation()
    console.log(companyId, siteId, systemId)
    this.config.changeCompanyId(companyId, false);
    this.router.navigate(['/dashboard/sites', siteId, 'system', systemId])

  }

}



